export default "__VITE_ASSET__Hp$LCcfA__"